"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var setFilterIdProperty = function setFilterIdProperty(rootRef, filterIds) {
  return function (i) {
    rootRef.current.style.setProperty("--squiggly__filter--id-".concat(i), "url('#".concat(filterIds[i], "')"));
  };
};
var _default = function _default(COUNT_OF_FILTERS, _ref) {
  var rootRef = _ref.rootRef,
    filterIds = _ref.filterIds;
  (0, _react.useEffect)(function () {
    if (rootRef.current) COUNT_OF_FILTERS.forEach(setFilterIdProperty(rootRef, filterIds));
  }, [filterIds]);
};
exports.default = _default;